<template>
  <section
    class="ln_section"
    :class="{ colorPa: game_id == 18 && area == 'us', colorJl: game_id == '14' && area == 'en' }"
  >
    <div class="part1">
      <div class="ln_head">
        <img class="header_logo" :src="require('@/assets/imgs/pay/header_logo.png')" alt="" />
        <ImageButton
          class="header_quetion"
          :src="require('@/assets/imgs/pay/icon_quetion.png')"
          alt=""
          @click.native="openInstructions"
        />
      </div>
      <div class="banner" v-if="bannerData.length">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#157cfc">
          <van-swipe-item v-for="(item, index) in bannerData" :key="index"
            ><a :href="item.url"><img :src="item.slideshow_url" alt=""/></a
          ></van-swipe-item>
        </van-swipe>
      </div>
      <div class="account">
        <div class="select">
          <div class="part-title">
            {{ $t('pay.title.SelectCharacter') }}
            <!-- 返回重新填写角色信息 -->
            <ImageButton
              v-if="isRoleConfirm"
              :src="require('@/assets/imgs/pay/icon_edit.png')"
              alt=""
              style="width: 0.45rem;margin-left: 0.2rem;"
              @click.native="closeConfirm"
            />
            <!-- 引导角色弹窗按钮 -->
            <div class="icon_role_box">
              <img
                slot="button"
                class="iconRole"
                @click="handleFaqOpen"
                src="../../assets/imgs/FAQ.png"
                alt=""
              />
            </div>
          </div>

          <!-- 未确认时，需填写角色信息 -->
          <template v-if="!isRoleConfirm">
            <div class="select-part-top">
              <!-- 如果是pa_game需要选择大区 -->
              <PopSelectItem v-if="hasRegion" @click.native="popSelect(1)">
                {{ area_name || $t('pay.Region') }}
              </PopSelectItem>
              <!-- 选择服务器 -->
              <PopSelectItem @click.native="popSelect(2)">
                {{ server_name || (hasRegion ? $t('pay.Server') : $t('pay.ServerPlaceholder')) }}
              </PopSelectItem>

              <!-- 选择角色ID -->
              <PopSelectItem>
                <input v-if="isRoleName" class="none-style-input" type="text" v-model="role_id" :placeholder="$t('pay.CharacterName')" />
                <input v-else class="none-style-input" type="text" v-model="role_id" :placeholder="$t('pay.CharacterID')" />
              </PopSelectItem>
            </div>
            <LnButton type="primary" style="margin-top: 0.2rem;" @click.native="confirmAccountInfo">{{
              $t('common.search')
            }}</LnButton>
          </template>

          <!-- 填写后，显示【角色信息确认】模块 -->
          <template v-else>
            <div class="role-confirm">
              <ul>
                <li>{{ $t('pay.Server') }}: {{ roleInfo.server_name }}</li>
                <li>{{ $t('pay.CharacterID') }}: {{ roleInfo.role_id }}</li>
                <li>{{ $t('pay.RoleName') }}: {{ roleInfo.role_name }}</li>
              </ul>
              <LnButton type="primary" :disabled="isRoleConfirmed" @click.native="confirmRoleInfo">{{
                isRoleConfirmed ? $t('common.confirmed') : $t('common.confirm')
              }}</LnButton>
            </div>
          </template>

          <!-- 选择弹窗 -->
          <van-popup v-model="showPicker" position="bottom">
            <van-field
              clickable
              v-model="keySearch"
              left-icon="search"
              :placeholder="$t('common.search')"
              @input="search"
            ></van-field>
            <van-picker
              show-toolbar
              :columns="filterColums"
              :confirm-button-text="$t('common.confirm')"
              :cancel-button-text="$t('common.cancel')"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
        </div>
        <div class="announceWrap" v-if="announceList.length">
          <div class="announce">
            <img style="width: 0.4rem; height: 0.4rem; margin-right: 0.2rem;" src="../../assets/imgs/notice.png" alt="">
            <div style="flex: 1;">
              <van-notice-bar :scrollable="false" background="#F1F1F1">
                <van-swipe
                  vertical
                  class="notice-swipe" 
                  :autoplay="3000"
                  :show-indicators="false"
                >
                  <van-swipe-item @click="handleAnnounceOpen" v-for="item in announceList" :key="item.title">
                    <div class="announce_item">
                      <div class="item_label">{{ $t('pay.announce.type') }}</div>
                      <div class="item_right">
                        <span class="line"></span>
                        <div class="adm_ellipsis">{{ item.title }}</div>
                      </div>
                    </div>
                  </van-swipe-item>
                </van-swipe>
              </van-notice-bar>
            </div>
            <div @click="handleAnnounceOpen">
              <van-icon v-if="showAnnouncePop" name="arrow-up" color="#ABABAB" size="0.2rem" style="margin-left: 0.1rem;" />
              <van-icon v-else name="arrow-down" color="#ABABAB" size="0.2rem" style="margin-left: 0.1rem;" />
            </div>
          </div>
          <van-popup v-model="showAnnouncePop" round position="bottom" class="announce_dialog">
            <div class="announce_pop">
              <van-icon class="announce_close" name="close" @click="handleAnnounceClose" />
              <div class="pop_title">{{ $t('common.announce') }}</div>
              <div class="pop_content">
                <div class="announce_item" v-for="item in announceList" :key="item.title">
                  <div class="item_left">{{ $t('pay.announce.type') }}</div>
                  <div class="item_right">{{ item.content }}</div>
                </div>
              </div>
            </div>
          </van-popup>
        </div>
      </div>
    </div>

    <div class="ln_content">
      <div class="prod">
        <!-- 商品列表标签页 -->
        <div class="tab">
          <div
            class="tabList"
            :class="{ tabListCurr: currIndex == index }"
            v-for="(item, index) in tabList"
            @click="changeProdList(item, index)"
            :key="index"
          >
            <span class="tab-tilte">
              {{ item }}
            </span>
            <van-icon name="arrow-down" />
          </div>
        </div>

        <div class="prod-list-with-title">
          <div class="part-title">{{ $t('pay.title.SelectBundle') }}</div>
          <!-- 商品列表 -->
          <div class="prodCont">
            <div class="prodList" v-for="item in priceData" :key="item.id">
              <ProdItem :item="item" :area="area" @openProdDesc="openProdDesc" :onPayProd="payProd"></ProdItem>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Protocal></Protocal>

    <!-- 角色ID教程弹窗 -->
    <div class="roleIdPop" v-if="isRolePop" @click="isRolePop = false">
      <img :src="roleImgUrl" @click.stop alt="" />
    </div>

    <cust></cust>
    <van-overlay :show="showPaintFace" @click="showPaintFace = false">
      <div class="paint_face_warp">
        <div class="container">
          <img class="paint_face" :src="paintFaceUrl" alt="">
          <div class="close_icon_box">
            <img class="close_icon" src="../../assets/imgs/slapFaceClose.png" alt="" @click="showPaintFace = false">
          </div>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showFaqDialog" class="faq_dialog">
      <div class="faq_warp">
        <div style="position: relative;">
          <van-icon class="faq_close" name="close" @click="handleFaqClose" />
          <div class="faq_title">FAQ</div>
          <div class="line"></div>
        </div>
        <div class="faq_content">
          <div v-html="faqContent"></div>
        </div>
      </div>
    </van-popup>
  </section>
</template>
<script>
import { getUrlParams } from '@/utils';
import { axiosServer } from '@/api/http';
import { Dialog, Toast, ImagePreview } from 'vant';
import { getSign } from '@/api/utils';
import cust from '../../components/customer.vue';
import ImageButton from '../../components/ImageButton.vue';
import Instructions from './components/Instructions.vue';
import { useDialog } from '@/features/dialog';
import PopSelectItem from './components/PopSelectItem.vue';
import LnButton from '../../components/LnButton.vue';
import ProdItem from './components/ProdItem.vue';
import Protocal from './components/Protocal.vue';
import { ref } from '@vue/composition-api';
import i18n, { getLocale, handleI18nWhenLocaleChange } from '../../i18n';
import newSubmit from './newSubmit.vue';

export default {
  // 用于keep-alive缓存
  name: 'index',
  components: {
    cust,
    ImageButton,
    PopSelectItem,
    LnButton,
    ProdItem,
    Protocal
  },
  data() {
    return {
      bannerData: [],
      game_id: '',
      area: '',
      app_key: '1df869f2e620513484ddbd5521313a60',
      isRoleConfirm: false,
      value: '',
      columns: [],
      showPicker: false,
      role_id: '',
      uid: '',
      role_name: '',
      area_id: '',
      area_name: '',
      popType: '',
      server_name: '',
      server_id: '',
      server_sign: '',
      tabList: [],
      type: '',
      priceData: [],
      pmx_show: [],
      roleInfo: {},
      roleInfoData: {},
      isRolePop: false,
      roleImgUrl: '',
      currIndex: 0,
      pcwidth: false,
      product_id: '',
      keySearch: '',
      filterColums: [],
      finish_pay: '',
      isRoleName: false,
      showAnnouncePop: false,
      announceList: [],
      showPaintFace: false,
      paintFaceUrl: "",
      showFaqDialog: false,
      faqContent: ''
    };
  },
  computed: {
    pa_game() {
      return this.game_id == 18 && ['us', 'eu', 'en'].includes(this.area);
    },
    /**
     * 是否是神火大陆EU平台
     * 1.研发传area=en|area=eu（SEA平台的传EN，另外两个平台传EU）（但是依然维护area=us的链接，跟pa项目做法保持一致）
     * 2.area=eu时，需要选择Region=EU|AM
     */
    isShdlEu() {
      return this.game_id == 44 && ['us', 'eu'].includes(this.area);
    },
    isSlxy() {
      return this.game_id == 232 && ['en'].includes(this.area);
    },
    isLfcs() {
      return this.game_id == 134 && ['multi'].includes(this.area);
    },
    // 是否需要选择region
    hasRegion() {
      return this.pa_game || this.isShdlEu || this.isSlxy || this.isLfcs;
    },
    regionList() {
      return this.isShdlEu
        ? [
            { text: 'AM', id: 'am' },
            { text: 'EU', id: 'eu' }
          ]
        : this.isSlxy 
        ? [
          { text: 'Asia', id: 'asia' },
          { text: 'America', id: 'america' },
          { text: 'Europe', id: 'europe' }
        ] : this.isLfcs
        ? [
          { text: 'NA', id: 'us' },
          { text: 'EU', id: 'eu' }
        ]
        :[
          { text: 'NA', id: 'us' },
          { text: 'EU', id: 'eu' },
          { text: 'AS', id: 'en' } // 显示是as，传参是en
        ];
    }
  },
  setup() {
    const { dialog, confirmDialog } = useDialog();
    // 是否已经确认了角色信息
    const isRoleConfirmed = ref(false);

    // 打开说明弹窗
    async function openInstructions() {
      await dialog(Instructions);
    }

    function toggleIsRoleConfirmed() {
      isRoleConfirmed.value = !isRoleConfirmed.value;
    }

    async function reenterConfirm() {
      await confirmDialog({
        message: i18n.t('pay.dialogMessage.reenter'),
        showCancelButton: true
      });
    }

    return {
      dialog,
      confirmDialog,
      openInstructions,
      isRoleConfirmed,
      toggleIsRoleConfirmed,
      reenterConfirm
    };
  },

  mounted() {
    console.log(window.innerWidth);

    if (window.innerWidth > 1000) {
      this.pcwidth = true;
    } else {
      this.pcwidth = false;
    }
  },
  created() {
    handleI18nWhenLocaleChange(this);
    const game_id_from_url = this.getValueFromUrl('game_id');
    const role_id_from_url = this.getValueFromUrl('role_id');
    const from_from_url = this.getValueFromUrl('from');
    const region_from_url = this.getValueFromUrl('region');

    if (game_id_from_url) {
      this.game_id = game_id_from_url;
      localStorage.setItem('game_id', game_id_from_url);
    }

    if (getUrlParams('area')) {
      this.area = getUrlParams('area');
      localStorage.setItem('area', getUrlParams('area'));
    }

    if (role_id_from_url) {
      this.role_id = role_id_from_url;
      localStorage.setItem('role_id', role_id_from_url);
    }

    localStorage.setItem('from', from_from_url || '');

    if (this.$route.query.area) {
      if (
        this.$route.query.area == localStorage.getItem('area') ||
        (this.$route.query.area == 'us' && localStorage.getItem('area') == 'eu')
      ) {
        this.area_name = localStorage.getItem('area_name') || '';
        this.server_name = localStorage.getItem('server_name') || '';
        if (localStorage.getItem('roleInfo')) {
          this.roleInfoData = JSON.parse(localStorage.getItem('roleInfo'));
          this.roleInfo = this.roleInfoData;
          if (this.$route.query.role_id) {
            this.role_id = this.$route.query.role_id;
          } else {
            this.role_id = this.roleInfoData.role_id || '';
          }
          this.uid = this.roleInfoData.uid || '';
          this.server_id = this.roleInfoData.server_id || '';
        }
      } else {
        localStorage.setItem('area_name', '');
        localStorage.setItem('server_name', '');
        localStorage.setItem('roleInfo', '');
      }
      if (localStorage.getItem('area') == 'eu' && this.$route.query.area == 'us') {
        localStorage.setItem('area', 'eu');
      } else {
        localStorage.setItem('area', this.$route.query.area);
      }
      this.area = localStorage.getItem('area');

      this.finish_pay = this.$route.query.finish_pay || '';
      this.isRoleConfirmed = !!this.finish_pay;
      this.isRoleConfirm = !!this.finish_pay;
      // console.log(this.isRoleConfirmed, '当前是否确认')

      // 真红（284）处理成角色名
      if (game_id_from_url == '284') {
        this.isRoleName = true;
      } else {
        this.isRoleName = false;
      }
    }

    // 回显region
    this.area_id = region_from_url || this.area;
    if (region_from_url) {
      const areaItem = this.regionList.find(item => item.id == region_from_url);
      this.area_name = areaItem ? areaItem.text : '';
      // console.log(this.area_name, '地区名称')
    }
    // 神罗仙域（game_id=232&area=en）大区默认显示America
    if (this.game_id == 232 & this.area == 'en') {
      // 当链接上有region时，以region为准
      if (region_from_url) {
        this.area_id = region_from_url;
        const areaItem = this.regionList.find(item => item.id == region_from_url);
        this.area_name = areaItem ? areaItem.text : '';
      } else {
        this.area_id = 'america';
        const areaItem = this.regionList.find(item => item.id == this.area_id);
        this.area_name = areaItem ? areaItem.text : '';
      }
    }
    this.getBanners();
    this.getServers();
    this.getCurrTab();
    this.getWebPayConfig();
    // this.getPayPriceList();
  },
  methods: {
    getValueFromUrl(key) {
      return getUrlParams(key) || this.$route.query[key];
    },
    getComputedArea() {
      // 只有pa是返回area_id的，其它的包括神火大陆eu都是返回area
      return this.pa_game ? this.area_id : this.area;
    },
    getBanners() {
      axiosServer({
        url: 'banners',
        type: 'post',
        params: {
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { game_id: this.game_id, area: this.area })
        }
      }).then(res => {
        let resa = res.data;
        if (resa.ret == 0) {
          this.bannerData = resa.data;
        } else {
          this.confirmDialog({
            message: resa.msg
          });
        }
      });
    },
    getCurrTab() {
      axiosServer({
        url: 'getTab',
        type: 'post',
        params: {
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { game_id: this.game_id, area: this.area })
        }
      }).then(res => {
        let resa = res.data;
        if (resa.ret == 0) {
          this.pmx_show = resa.data.pmx_show;
          resa.data.pay_type_list &&
            resa.data.pay_type_list.forEach((v, x) => {
              if (x == 0) {
                v.checked = true;
              } else {
                v.checked = false;
              }
            });
          localStorage.setItem('payWays', JSON.stringify(resa.data.pay_type_list));
          this.tabList = resa.data.tab_list;
          this.type = this.tabList[0] || '';
          this.getPayPriceList();
          this.reportEvent(1);
        } else {
          this.confirmDialog({
            message: resa.msg
          });
        }
      });
    },
    getWebPayConfig() {
      axiosServer({
        url: 'getWebPayConfig',
        type: 'post',
        params: {
          game_id: this.game_id,
          area: this.area,
          sign: getSign(this.app_key, { game_id: this.game_id, area: this.area })
        }
      }).then(res => {
        let resa = res.data;
        if (resa.ret == 0) {
          this.announceList = resa.data.notice_config || [];
          this.paintFaceUrl = resa.data.popup_url || "";
          this.faqContent = resa.data.faq_content || "";
          if(this.paintFaceUrl) {
            this.isShowPaintFace();
          }
        } else {
          this.confirmDialog({
            message: resa.msg
          });
        }
      });
    },
    isShowPaintFace() {
      const SLAP_STORAGE_KEY = 'lastSlapDate';
      const today = new Date().toISOString().split('T')[0];
      const lastSlapDate = localStorage.getItem(SLAP_STORAGE_KEY);
      if (lastSlapDate !== today) {
        this.showPaintFace = true;
        localStorage.setItem(SLAP_STORAGE_KEY, today);
      }
    },
    search() {
      // console.log(this.columns);
      this.filterColums = this.columns.filter(item => item.text.includes(this.keySearch));
    },
    changeProdList(row, index) {
      this.type = row;
      this.currIndex = index;
      this.reportEvent(2);
      this.getPayPriceList();
    },
    getPayPriceList() {
      Toast.loading();
      axiosServer({
        url: 'getPayPrice',
        type: 'post',
        params: {
          type: this.type,
          game_id: this.game_id,
          area: this.area,
          role_id: this.roleInfoData.role_id || this.role_id,
          ln_uid: this.roleInfoData.uid || this.uid,
          sign: getSign(this.app_key, {
            type: this.type,
            game_id: this.game_id,
            area: this.area,
            role_id: this.roleInfoData.role_id || this.role_id,
            ln_uid: this.roleInfoData.uid || this.uid
          })
        }
      }).then(res => {
        let resa = res.data;

        Toast.clear();
        if (resa.ret == 0) {
          this.priceData = resa.data;
        } else {
          this.confirmDialog({
            message: resa.msg
          });
        }
      });
    },
    popSelect(type) {
      this.showPicker = true;
      if (type == 1) {
        this.columns = this.regionList;
        this.filterColums = this.regionList;
        console.log(this.regionList, '1111')
      } else {
        this.filterColums = this.serveList;
      }
      this.keySearch = '';
      this.popType = type;
    },
    openRolePop() {
      // console.log('111')
      if (this.game_id == '14') {
        this.roleImgUrl = require('../../assets/imgs/role_jlsy.jpg');
      } else if (this.game_id == '136') {
        this.roleImgUrl = require('../../assets/imgs/role_wyqt.jpg');
      } else if (this.game_id == '18') {
        if (this.area == 'kr') {
          this.roleImgUrl = require('../../assets/imgs/role_lmzt_kr.jpg');
        } else {
          this.roleImgUrl = require('../../assets/imgs/role_lmzt.jpg');
        }
      } else if (this.game_id == '44') {
        if (this.area == 'kr') {
          this.roleImgUrl = require('../../assets/imgs/shdl-kr.jpg');
        } else {
          this.roleImgUrl = require('../../assets/imgs/shdl.jpg');
        }
      } else if (this.game_id == '182') {
        this.roleImgUrl = require('../../assets/imgs/nwszj.jpg');
      } else if (this.game_id == '134') {
        this.roleImgUrl = require('../../assets/imgs/lfcs.png');
      }
      // this.isRolePop = true;
      ImagePreview({ images: [this.roleImgUrl], closeable: true });
    },
    getServers() {
      let post_area = this.getComputedArea();
      axiosServer({
        url: 'getServerList',
        type: 'post',
        params: {
          game_id: this.game_id,
          area: post_area,
          sign: getSign(this.app_key, { game_id: this.game_id, area: post_area }),
          region: (this.isShdlEu || this.isSlxy || this.isLfcs) ? this.area_id : '' // 神火大陆eu/传多一个region参数
        }
      }).then(resa => {
        let res = resa.data;
        if (res.ret == 0) {
          this.serveList = res.data;
          res.data.forEach(v => {
            v.text = v.server_name;
          });
          this.columns = res.data;
          this.filterColums = res.data;
          const server_id_from_url = this.getValueFromUrl('server_id');
          // const role_id_from_url = this.getValueFromUrl('role_id');

          if (server_id_from_url) {
            this.server_id = server_id_from_url;
            this.server_name = res.data.filter(item => item.server_id == server_id_from_url)[0].server_name;
            console.log(this.server_id);
            if (this.game_id == '134') {
              this.server_sign = res.data.filter(item => item.server_id == server_id_from_url)[0].server_sign;
            }
          }

          // if (server_id_from_url && role_id_from_url) {
          //   this.confirmRole(false, {}, 1);
          // }
        } else {
          this.confirmDialog({
            message: res.msg
          });
        }
      });
    },
    confirmRole(submit, row, init) {
      if (!this.role_id) {
        this.confirmDialog({
          message: this.$t('pay.dialogMessage.fillCharacterID')
        });
        return;
      }
      let params = this.game_id == '134' ? {
        role_id: this.role_id,
        server_id: this.server_id,
        server_sign: this.server_sign || '',
        area: this.pa_game ? this.area_id : localStorage.getItem('area'),
        game_id: this.game_id
      } : {
        role_id: this.role_id,
        server_id: this.server_id,
        area: this.pa_game ? this.area_id : localStorage.getItem('area'),
        game_id: this.game_id
      };
      if (this.game_id == '284') {
        params.role_id = '';
        params.role_name = this.role_id;
      }      const { dialog } = this;
      axiosServer({
        url: 'getRoleInfo',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(async (resa) => {
        let res = resa.data;
        if (res.ret == 0) {
          if (!submit && !init) {
            this.isRoleConfirm = true;
          }
          this.roleInfo = res.data;
          this.area = this.getComputedArea();
          localStorage.setItem('area', this.area);
          localStorage.setItem('area_name', this.area_name);
          localStorage.setItem('server_name', this.server_name);
          localStorage.setItem('roleInfo', JSON.stringify(res.data));
          this.uid = res.data.uid;
          if (submit) {
            this.product_id = row.id;
            this.reportEvent(3);
            // await dialog(
            //   newSubmit,
            //   { detailData: { ...row, pmx_show: this.pmx_show, type: this.type, roleInfo: JSON.stringify(this.roleInfo), server_sign: this.server_sign || '' } },
            // );
            this.$router.push({
              path: '/submit',
              query: { ...row, pmx_show: this.pmx_show, type: this.type, roleInfo: JSON.stringify(this.roleInfo), server_sign: this.server_sign || '' }
            });
          }

          if (init) {
            this.confirmRoleInfo();
          }
        } else {
          // this.roleInfoData = {};
          // this.uid = '';
          // this.role_id = '';
          // this.priceData = [];
          // this.getPayPriceList();
          this.confirmDialog({
            message: res.msg
          });
        }
      });
    },
    onConfirm(data) {
      console.log(data);
      if (this.popType == 1) {
        this.area_name = data.text;
        this.area_id = data.id;
        this.server_name = '';
        this.getServers();
      } else if (this.popType == 2) {
        this.server_name = data.server_name;
        this.server_id = data.server_id;
        if (this.game_id == '134') {
          this.server_sign = data.server_sign;
        }
      }
      this.showPicker = false;
    },

    // 打开商品详情弹窗
    async openProdDesc(item) {
      const { dialog } = this;
      await dialog(
        ProdItem,
        { item, area: this.area, isDetail: true, onPayProd: this.payProd },
        {
          title: this.$t('pay.bundelDetails'),
          showConfirmButton: false
        }
      );
    },

    payProd(row) {
      // 需要点击确认角色信息后，才能跳转
      if (!this.isRoleConfirmed) {
        this.confirmDialog({
          message: this.$t('pay.dialogMessage.confirmCharacter')
        });
        return;
      }
      this.confirmRole(1, row);
      // this.$router.push({ path: '/submit', query: { ...row, pmx_show: this.pmx_show, type: this.type,roleInfo: this.roleInfoData } });
    },
    async confirmAccountInfo() {
      if (!this.server_id) {
        await this.confirmDialog({
          message: this.$t('pay.dialogMessage.selectServer')
        });
        return;
      }
      if (!this.role_id) {
        await this.confirmDialog({
          message: this.$t('pay.dialogMessage.selectRoleId')
        });
        return;
      }
      this.confirmRole();
    },
    reportEvent(event) {
      let params = {
        game_id: this.game_id,
        area: this.area,
        product_id: this.product_id,
        product_type: this.type,
        report_type: event,
        from: localStorage.getItem('from')
      };
      axiosServer({
        url: 'report',
        type: 'post',
        params: {
          ...params,
          sign: getSign(this.app_key, params)
        }
      }).then(res => {
        console.log(res);
      });
    },
    async closeConfirm() {
      await this.reenterConfirm();
      this.isRoleConfirm = false;
      this.isRoleConfirmed = false;
    },
    confirmRoleInfo() {
      // this.isRoleConfirm = false;
      this.isRoleConfirmed = true;
      this.roleInfoData = this.roleInfo;
      this.getPayPriceList();
      this.reportEvent(7);
    },
    handleAnnounceOpen() {
      this.showAnnouncePop = true;
    },
    handleAnnounceClose() {
      this.showAnnouncePop = false;
    },
    handleFaqOpen() {
      this.showFaqDialog = true;
    },
    handleFaqClose() {
      this.showFaqDialog = false;
    }
  }
};
</script>
<style lang="scss">
.ln_section {
  background: #f3f3f3;
  .part1 {
    padding: 0 0.45rem 0.45rem;
    background: white;
    .ln_head {
      background: white;
      height: 1.09rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .header_logo {
        width: 3.56rem;
      }
      .header_quetion {
        width: 0.55rem;
        height: 0.55rem;
      }
    }
    .banner {
      height: 3.33rem;
      .van-swipe {
        height: 100%;
      }
      img {
        height: 100%;
        border-radius: 0.15rem;
        width: 100%;
      }
    }
    .account {
      background: white;
      margin-top: 0.04rem;
      .title {
        width: 100%;
        height: 0.59rem;
        background: #29c0ff;
        text-align: center;
        color: #fff;
        line-height: 0.59rem;
        border-radius: 0.1rem;
      }
      .select {
        .select-part-top {
          display: flex;
          .pop-select-item {
            input {
              width: 100%;
              margin: 0 0.2rem;
            }
            + .pop-select-item {
              margin-left: 0.2rem;
            }
          }
        }
        .van-cell {
          padding: 0.12rem 0.12rem 0.2rem 0;
        }
      }
      .role-confirm {
        font-family: SourceHanSansCN;
        font-weight: 400;
        font-size: 0.2rem;
        color: #000000;
        line-height: 0.51rem;
        display: flex;
        align-items: center;
        > ul {
          flex: 1;
        }
      }
      .icon_role_box {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-top: 0.1rem;
      }
      .iconRole {
        width: 0.9rem;
      }
    }
    .announceWrap {
      margin-top: 0.2rem;
      .announce {
        box-shadow: none;
        padding-inline-end: 0;
        align-items: center;
        background-color: #F1F1F1;
        border-radius: 0.1rem;
        cursor: pointer;
        display: flex;
        height: 0.7rem;
        padding: 0.15rem 0.22rem;
        position: relative;
        transition: all .25s ease;
        .van-notice-bar {
          padding: 0;
          height: 0.4rem;
        }
        .announce_item {
          font-family: SourceHanSansCN;
          align-items: center;
          display: flex;
          width: 100%;
          .item_label {
            color: #FFC100;
            font-size: 0.22rem;
          }
          .item_right {
            align-items: center;
            display: flex;
            flex: 1;
            .line {
              background-color: #ABABAB;
              height: 0.4rem;
              margin: 0 0.16rem;
              width: 0.03rem;
            }
            .adm_ellipsis {
              flex: 1;
              font-size: 0.22rem;
              font-weight: 500;
              color: #000;
              width: 3.8rem;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
      .announce_dialog {
        width: 100%;
        display: flex;
        justify-content: center;
        background-color: transparent;
      }
      .announce_pop {
        width: 7.2rem;
        position: relative;
        background-color: #fff;
        border-radius: 16px 16px 0 0;
        overflow: auto;
        .pop_title {
          padding: 0 1rem;
          align-items: center;
          display: flex;
          font-family: SourceHanSansCN;
          //font-size: 0.3rem;
          font-size: 16px;
          font-weight: 500;
          //height: 1rem;
          height: 50px;
          //line-height: 0.4rem;
          line-height: 20px;
          position: relative;
          width: 100%;
          text-align: center;
          justify-content: center;
        }
        .pop_content {
          padding: 0.4rem 0.4rem 1rem;
          .announce_item {
            align-items: flex-start;
            flex-direction: column;
            display: flex;
            flex: 1 1;
            font-family: PingFangSC-Medium, PingFang SC;
            //font-size: 0.28rem;
            font-size: 14px;
            font-weight: 500;
            .item_left {
              color: #f8aa1f;
              margin-bottom: 0.1rem;
            }
            .item_right {
              text-align: justify;
              margin-bottom: 0.4rem;
              white-space: pre-wrap;
            }
          }
        }
        .announce_close {
          position: absolute;
          //font-size: 0.4rem;
          font-size: 20px;
          cursor: pointer;
          right: 0.3rem;
          top: 0.3rem;
          z-index: 999;
        }
      }
    }
  }

  .ln_content {
    margin-top: 0.3rem;
    background: white;

    .prod {
      .tab {
        display: flex;
        justify-content: space-around;
        background: #f3f3f3;
        .tabList {
          flex: 1;
          flex-basis: 0;
          height: 0.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgb(243, 243, 243);
          color: #ababab;
          // border-top: 1px solid #dddddd;
        }
        .tabListCurr {
          color: #ffc100;
          background: #ffffff;
        }
      }
      .prod-list-with-title {
        padding: 0 0.45rem 0.55rem;
        .part-title {
          padding: 0.4rem 0;
        }
        .prodCont {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 0.2rem;

          .prodList {
          }
        }
      }
    }
  }
  .ln_footer {
    width: 100%;
    max-width: 720px;
    height: 1.6rem;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 0);
    background: #1b1b1b;
    text-align: center;
    color: #c6c6c6;
    div:nth-child(1) {
      padding-top: 0.2rem;
      img {
        width: 1rem;
      }
    }
    div:nth-child(2) {
      margin-top: 0.1rem;
    }
  }
}

.role_dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  .dialog_cont {
    width: 5.06rem;
    height: 3.85rem;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 0.15rem;
    .dialog_desc {
      text-align: center;
      padding: 0.25rem 0.25rem 0;
      .title {
        font-size: 0.3rem;
        font-weight: 700;
        color: #000;
      }
      .desc_list {
        font-size: 0.25rem;
        color: #000;
        margin-top: 0.15rem;
        display: flex;
        span {
          display: inline-block;
          text-align: right;
        }
        span:nth-child(1) {
          width: 1.4rem;
        }
        span:nth-child(2) {
          margin-left: 0.3rem;
        }
      }
    }
    .dialog_btn {
      margin-top: 0.3rem;
      display: flex;
      padding: 0 0.36rem;
      justify-content: space-between;
      div {
        font-size: 0.26rem;
        color: #fff;
        border-radius: 0.1rem;
        width: 2rem;
        height: 0.6rem;
        line-height: 0.6rem;
        text-align: center;
      }
      div:nth-child(1) {
        background: #a0a0a0;
      }
      div:nth-child(2) {
        background: #29c0ff;
        font-weight: bold;
      }
    }
  }
}

.none-style-input {
  background: transparent;
  border: none;
  outline: none;
  text-align: center;
  &::placeholder {
    color: inherit;
  }
}
.ln-dialog:has(.new_submit_prod) {
  border-radius: 0;
  .ln-dialog-body {
    padding: 0;
  }
  .ln-dialog-footer {
    padding: 0;
  }
}
.notice-swipe {
  padding: 0;
  height: 0.4rem;
  line-height: 0.4rem;
}
.paint_face_warp {
  max-width: 720px;
  width: calc(100vw - 30px);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .container {
    margin: auto;
    max-height: 70vh;
    text-align: center;
  }
  .paint_face {
    max-width: 100%;
    max-height: 60vh;
  }
  .close_icon_box {
    display: flex;
    justify-content: center;
    margin-top: 10px;
  }
  .close_icon {
    width: 30px;
    height: 30px;
  }
}
.faq_dialog {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: transparent;
  .faq_warp {
    width: 6.2rem;
    max-height: 86vh;
    position: relative;
    background-color: #fff;
    border-radius: 16px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    .faq_title {
      padding: 0 1rem;
      align-items: center;
      display: flex;
      font-family: SourceHanSansCN;
      //font-size: 0.3rem;
      font-size: 16px;
      font-weight: bold;
      //height: 1rem;
      height: 50px;
      //line-height: 0.4rem;
      line-height: 20px;
      position: relative;
      width: 100%;
      text-align: center;
      justify-content: center;
    }
    .faq_close {
      position: absolute;
      //font-size: 0.4rem;
      font-size: 20px;
      cursor: pointer;
      right: 0.3rem;
      top: 0.3rem;
      z-index: 999;
    }
    .line {
      width: 5.8rem;
      margin: auto;
      height: 1px;
      background-color: #ababab;
    }
    .faq_content {
      font-size: 12px;
      padding: 0.3rem 0.7rem;
      flex: 1;
      overflow: auto;
      img {
        width: 100%;
        max-width: 100%;
        height: auto !important;
        margin: 0 auto;
        display: block;
      }
      p {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
<style lang="scss">
.submit_dialog {
  overscroll-behavior: contain;
  .ln-dialog {
    border-radius: 0;
    .ln-dialog-body {
      padding: 0;
    }
    .ln-dialog-footer {
      padding: 0;
    }
  }
}
</style>
